<template>
  <div v-if="!currentQuote.customer_rejected_at">
    <p class="instant-quote-price-and-schedule--quote-text" test-id="quote_text">
      {{ currentQuote.customer_accepted_at ? 'Approved Quote:' : 'Your Quote:' }}
    </p>
    <div class="instant-quote-price-and-schedule--quote-price-wrapper">
      <LsIcon type="quote" size="xlg" class="instant-quote-price-and-schedule--quote-icon" />
      <div>
        <span class="instant-quote-price-and-schedule--price" test-id="price">
          {{ currentQuote.price | currency }}
        </span>
        <span class="instant-quote-price-and-schedule--price-text">{{ actionText }}</span>
      </div>
    </div>
    <div class="instant-quote-price-and-schedule--pending-wrapper">
      <div class="instant-quote-price-and-schedule--icon-wrapper">
        <LsIcon :type="getStatus.icon" :color="getStatus.color" size="sm" test-id="icon" />
      </div>
      <span test-id="pending_text">
        {{ getStatus.text }} <span class="has-text-weight-bold" test-id="date">{{ getDate }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsFilters, lsPropTypeHelpers } from 'ls-vue-common';
import { LsIcon } from '@/components/common';
import _ from 'lodash';

export default {
  name: 'InstantQuotePriceAndSchedule',
  components: { LsIcon },
  props: {
    currentQuote: VueTypes.shape({
      instant_quote_status: VueTypes.string.isRequired,
      instant_quote_status_set_at: VueTypes.string.isRequired,
      schedule_at: VueTypes.string.isRequired,
      customer_accepted_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
    }).isRequired.loose,
    date: VueTypes.shape({
      next_starts_at: VueTypes.string,
      next_ends_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
    }),
  },
  computed: {
    generateDateString() {
      const { next_starts_at, next_ends_at } = this.date;
      const { instant_quote_status, instant_quote_status_set_at } = this.currentQuote;

      if (
        instant_quote_status === 'completed' ||
        instant_quote_status === 'cancelled' ||
        instant_quote_status === 'unclaimed'
      ) {
        return `on ${lsFilters.date({ date: instant_quote_status_set_at })}`;
      }

      if (!next_ends_at || next_starts_at === next_ends_at) {
        return `on ${lsFilters.date({ date: next_starts_at })}`;
      }

      return `between ${lsFilters.date({ date: next_starts_at })} and ${lsFilters.date({
        date: next_ends_at,
      })}`;
    },
    getDate() {
      if (!_.get(this.currentQuote, 'schedule_at')) {
        return 'on your next service date.';
      }
      return this.date
        ? this.generateDateString
        : `on ${lsFilters.date({ date: this.currentQuote.schedule_at })}`;
    },
    getStatus() {
      const { instant_quote_status, customer_accepted_at } = this.currentQuote;
      const { name } = this.currentQuote[this.iqType].service;

      if (instant_quote_status === 'completed') {
        return {
          icon: 'checkmark',
          color: 'primary',
          text: `${name} was completed `,
        };
      }
      if (instant_quote_status === 'cancelled' || instant_quote_status === 'unclaimed') {
        return {
          icon: 'cancel',
          color: 'danger',
          text: `${name} was cancelled `,
        };
      }
      return {
        icon: 'calendar',
        color: 'primary',
        text: customer_accepted_at
          ? ` ${this.cycle ? `Your first ` : ``}${name} is scheduled to be completed`
          : `Pending your approval, ${
              this.cycle ? `your first ` : ``
            }${name} is scheduled to be completed`,
      };
    },
    iqType() {
      return this.currentQuote.type;
    },
    actionText() {
      return this.currentQuote[this.iqType].copy.action;
    },
    cycle() {
      return this.currentQuote[this.iqType].cycle;
    },
  },
};
</script>

<style lang="scss" scoped>
.instant-quote-price-and-schedule--quote-text {
  font-size: $size-3;
  color: $primary;
  font-weight: bold;
}

.instant-quote-price-and-schedule--quote-price-wrapper {
  display: flex;
  align-items: center;
  padding: 10px 0 20px 0;
}

.instant-quote-price-and-schedule--quote-icon {
  margin-top: -2px;
}

.instant-quote-price-and-schedule--price {
  margin-left: 8px;
  font-size: $size-1;
  color: $primary;
  font-weight: bold;
}

.instant-quote-price-and-schedule--price-text {
  font-size: $size-4;
  color: $primary;
  padding-left: 4px;
}

.instant-quote-price-and-schedule--icon-wrapper {
  margin: 1px 8px 0 0;
}

.instant-quote-price-and-schedule--pending-wrapper {
  display: flex;
  font-size: $size-5;
  padding: 20px;
  background-color: $primary-light;
  width: 100%;
}

.themed-app {
  .instant-quote-price-and-schedule--quote-text {
    font-size: $theme-txt-title-sm;
    color: $theme-color-primary;
  }

  .instant-quote-price-and-schedule--price {
    font-size: $theme-txt-headline;
    color: $theme-color-primary;
  }

  .instant-quote-price-and-schedule--price-text {
    font-size: $theme-txt-body-lg;
    color: $theme-color-primary;
  }

  .instant-quote-price-and-schedule--pending-wrapper {
    font-size: $theme-txt-body;
    background-color: $theme-color-primary-light;
  }
}
</style>
